import React, { Component } from 'react';
import { BannerComponent, Offline } from 'common/components';
import {
  infocircle as InfoCircle,
  offline as OfflineIcion,
} from 'common/svg/icons';
import * as constants from 'common/constants';
import './index.css';

class OfflineBanner extends Component {
  state = { showOfflineTooltip: false };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  render() {
    return (
      <Offline>
        <BannerComponent
          leftIcon={
            <div className="offlinebanner__container">
              <OfflineIcion />
            </div>
          }
          message={constants.OFFLINE_WARNING}
          rightIcon={
            <div className="offlinebanner__container">
              <span
                onClick={this.toggleOfflineTooltip}
                ref={node => (this.tooltipButton = node)}
              >
                <InfoCircle />
              </span>
              {this.getOfflineTooltip()}
            </div>
          }
          theme={[
            'strong',
            'danger',
            'fixed',
            'icon--left',
            'icon--right',
            'offline',
          ]}
        />
      </Offline>
    );
  }

  /**
   *
   *  Render offline tooltip
   * @memberof OfflineBanner
   * @function getOfflineTooltip
   */
  getOfflineTooltip = () => {
    if (this.state.showOfflineTooltip) {
      return (
        <div
          className="offlinebanner__tooltip"
          ref={node => (this.tooltipContainer = node)}
        >
          <h3 className="offlinebanner__tooltip__content">
            You can continue using the app although some features may not be
            available offline. Your data will be synced to cloud when you go
            online again.
          </h3>
        </div>
      );
    }
    return null;
  };

  /**
   *
   * Hide tooltip on outside click/press
   * @memberof OfflineBanner
   * @function handleClickOutside
   */
  handleClickOutside = e => {
    if (
      this.tooltipContainer &&
      this.tooltipButton &&
      !this.tooltipContainer.contains(e.target) &&
      !this.tooltipButton.contains(e.target) &&
      this.state.showOfflineTooltip
    ) {
      this.toggleOfflineTooltip();
    }
  };

  /**
   *
   * Toggle state
   * @memberof OfflineBanner
   * @function toggleOfflineTooltip
   */
  toggleOfflineTooltip = () =>
    this.setState({ showOfflineTooltip: !this.state.showOfflineTooltip });
}

export default OfflineBanner;



// WEBPACK FOOTER //
// ./src/containers/OfflineBanner/index.js